import { render, staticRenderFns } from "./create_temporary_agreement.vue?vue&type=template&id=e2644fd8"
import script from "./create_temporary_agreement.vue?vue&type=script&lang=js"
export * from "./create_temporary_agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports